import { Autocomplete, Box, TextField } from '@mui/material';
import { useMemo } from 'react';

import { PredictionModel } from '~/utils/transforms/predictionModelsDataTransforms';

type BodyPartSelectProps = {
    availableModels?: PredictionModel[];
    selectedBodyPart: string;
    setSelectedBodyPart: (part: string) => void;
};

export default function BodyPartSelect({
    availableModels,
    selectedBodyPart,
    setSelectedBodyPart,
}: BodyPartSelectProps) {
    const handleAutocompleteChange = (
        _: React.SyntheticEvent<Element, Event>,
        newValue: string | null
    ) => {
        if (newValue) {
            setSelectedBodyPart(newValue);
        }
    };

    const displayedBodyParts = useMemo(() => {
        const uniqueBodyPartLabels = Array.from(
            new Set(
                (availableModels || []).map((model) => model.bodyPart).filter(Boolean)
            )
        );
        return ['All', ...uniqueBodyPartLabels];
    }, [availableModels]);

    return (
        <Autocomplete
            options={displayedBodyParts}
            fullWidth
            autoHighlight
            defaultValue={displayedBodyParts[0]}
            value={selectedBodyPart}
            onChange={handleAutocompleteChange}
            disableClearable
            renderOption={(props, option) => {
                return (
                    <Box component="li" {...props} display="flex" gap={2}>
                        {option}
                    </Box>
                );
            }}
            renderInput={(params) => {
                return (
                    <TextField
                        {...params}
                        fullWidth
                        label="Body part"
                        size="small"
                        InputProps={{
                            ...params.InputProps,
                        }}
                    />
                );
            }}
        />
    );
}
